import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store';
import { PricesState, PRICES_SLICE_NAME } from './models';

export const pricesSelector = (state: RootState): PricesState => state[PRICES_SLICE_NAME];

export const selectPricesIsLoading = createSelector(pricesSelector, (state: PricesState) => state.isLoading);

export const selectPrice = createSelector(pricesSelector, (state: PricesState) => state.price);

export const selectAppraisePrices = createSelector(pricesSelector, (state: PricesState) => state.appraisePrices);

export const selectSettlementData = createSelector(pricesSelector, (state: PricesState) => state.settlementData);

export const selectPhotoShootingPrices = createSelector(
  pricesSelector,
  (state: PricesState) => state.photoShootingPrices,
);
